import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AddLoopHelpPageRoutingModule } from './add-loop-help-routing.module';

import { AddLoopHelpPage } from './add-loop-help.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule, AddLoopHelpPageRoutingModule],
  declarations: [AddLoopHelpPage]
})
export class AddLoopHelpPageModule {}
